var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes, on: { click: _vm.toggleEditMode } },
    [
      !_vm.editMode
        ? [
            _vm.loading
              ? _c("CompassSkeleton", {
                  style: { width: _vm.componentWidth + "px" },
                  attrs: { size: "x-large" }
                })
              : _c("div", { ref: "editSelectValue", class: _vm.valueClasses }, [
                  _vm.selectedItem.color
                    ? _c("span", {
                        staticClass: "edit-select__value-dot",
                        style: "backgroundColor: " + _vm.selectedItem.color
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.selectedItem.label) +
                          "\n            "
                      )
                    ]
                  )
                ])
          ]
        : _c(
            "CompassSelect",
            {
              ref: "editSelect",
              attrs: {
                size: _vm.size,
                value: _vm.selectedValue,
                forceSelectOpen: ""
              },
              on: {
                close: function($event) {
                  _vm.editMode = false
                },
                "update:value": _vm.handleValueUpdate
              }
            },
            _vm._l(_vm.items, function(item) {
              return _c("CompassDropdownSelectOption", {
                key: item.id,
                attrs: {
                  label: item.label,
                  value: item.id,
                  type: item.color ? "dot" : "text",
                  dotColor: item.color
                }
              })
            }),
            1
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }